import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{on-document @event @action}}\n{{#if @editorDocument}}\n  {{on @editorDocument @event @action}}\n{{/if}}", {
  moduleName: "@intercom/composer-ember/components/utils/multi-document-event-handler.hbs"
});